<div i18n="Stats|School teachers title@@stats-school-teachers-title"
     class="enrolled-title mat-body-strong">Enrolled teachers from this school:
</div>

<mat-spinner *ngIf="inProgress" color="primary" diameter="30" class="center progress"></mat-spinner>

<div *ngIf="!inProgress">
  <div *ngIf="!teacherStats || !teacherStats.length;else teachersData"
       i18n="General|No data provided@@general-no-data-provided">[no data]</div>

  <ng-template #teachersData>
    <teacher-info-table *ngIf="teacherStats"
                        [mobileView]="mobileView"
                        [contest]="contest"
                        [regions]="regions"
                        [teacherStats]="teacherStats"
                        [expandContent]="false"
                        [showPoints]="false"
                        [showRegion]="false"
                        [showEnrolled]="true"></teacher-info-table>
  </ng-template>
</div>
